import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TimelineTooltip } from './TimelineTooltip';

interface TimelineAnnotationProps {
  id: string;
  startTime: number;
  endTime: number;
  duration: number;
  color: string;
  text: string;
  onClick: (id: string) => void;
}

export function TimelineAnnotation({
  id,
  startTime,
  endTime,
  duration,
  color,
  text,
  onClick
}: TimelineAnnotationProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const start = (startTime / duration) * 100;
  const width = ((endTime - startTime) / duration) * 100;

  return (
    <motion.div
      className="tw-absolute tw-h-8 tw-rounded tw-cursor-pointer"
      style={{
        left: `${start}%`,
        width: `${width}%`,
        backgroundColor: color,
        top: '16px'
      }}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.02 }}
      onClick={(e) => {
        e.stopPropagation();
        onClick(id);
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            className="tw-relative tw-z-10"
          >
            <TimelineTooltip
              startTime={startTime}
              endTime={endTime}
              text={text}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}